import { render, staticRenderFns } from "./dnsCreate.vue?vue&type=template&id=ef2eecc6&scoped=true"
import script from "./dnsCreate.vue?vue&type=script&lang=js"
export * from "./dnsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2eecc6",
  null
  
)

export default component.exports